__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "spark";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.14.0", () => (Promise.all([__webpack_require__.e(7923), __webpack_require__.e(7135), __webpack_require__.e(4158)]).then(() => (() => (__webpack_require__(4158))))));
			register("@emotion/styled", "11.14.1", () => (Promise.all([__webpack_require__.e(7870), __webpack_require__.e(1479)]).then(() => (() => (__webpack_require__(1479))))));
			register("@mui/material/styles", "9.1.0", () => (Promise.all([__webpack_require__.e(9812), __webpack_require__.e(4385), __webpack_require__.e(7737), __webpack_require__.e(7135), __webpack_require__.e(2275), __webpack_require__.e(2168)]).then(() => (() => (__webpack_require__(4385))))));
			register("@mui/material", "9.1.0", () => (Promise.all([__webpack_require__.e(9812), __webpack_require__.e(4385), __webpack_require__.e(7757), __webpack_require__.e(7737), __webpack_require__.e(2557), __webpack_require__.e(8001), __webpack_require__.e(7135), __webpack_require__.e(2275), __webpack_require__.e(61), __webpack_require__.e(2168)]).then(() => (() => (__webpack_require__(2557))))));
			register("@mui/system", "9.1.0", () => (Promise.all([__webpack_require__.e(7923), __webpack_require__.e(9812), __webpack_require__.e(7757), __webpack_require__.e(3774), __webpack_require__.e(7135), __webpack_require__.e(2275)]).then(() => (() => (__webpack_require__(3774))))));
			register("@mui/x-license", "9.4.0", () => (__webpack_require__.e(5305).then(() => (() => (__webpack_require__(5305))))));
			register("final-form", "4.20.10", () => (__webpack_require__.e(4975).then(() => (() => (__webpack_require__(7356))))));
			register("history", "4.10.1", () => (__webpack_require__.e(7929).then(() => (() => (__webpack_require__(7929))))));
			register("i18next", "20.6.1", () => (Promise.all([__webpack_require__.e(8521), __webpack_require__.e(4467)]).then(() => (() => (__webpack_require__(8521))))));
			register("mobx-react", "7.6.0", () => (Promise.all([__webpack_require__.e(4015), __webpack_require__.e(61), __webpack_require__.e(4683)]).then(() => (() => (__webpack_require__(4015))))));
			register("mobx", "6.16.1", () => (__webpack_require__.e(7813).then(() => (() => (__webpack_require__(7813))))));
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(961))), 1);
			register("react-final-form", "6.5.9", () => (Promise.all([__webpack_require__.e(952), __webpack_require__.e(8062), __webpack_require__.e(8587)]).then(() => (() => (__webpack_require__(952))))));
			register("react-i18next", "11.18.6", () => (__webpack_require__.e(3992).then(() => (() => (__webpack_require__(3992))))));
			register("react-is", "18.3.1", () => (__webpack_require__.e(4363).then(() => (() => (__webpack_require__(4363))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(2906), __webpack_require__.e(275), __webpack_require__.e(7006)]).then(() => (() => (__webpack_require__(4625))))));
			register("react-router", "5.3.4", () => (Promise.all([__webpack_require__.e(6347), __webpack_require__.e(7135), __webpack_require__.e(2906), __webpack_require__.e(1022)]).then(() => (() => (__webpack_require__(6347))))));
			register("react", "18.3.1", () => (() => (__webpack_require__(6540))), 1);
			initExternal(8136);
			initExternal(3248);
			initExternal(980);
			initExternal(1756);
			initExternal(8646);
			initExternal(8482);
			initExternal(4024);
			initExternal(3312);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};